import { render, staticRenderFns } from "./case1.vue?vue&type=template&id=47e539ce&scoped=true&"
import script from "./case1.vue?vue&type=script&lang=js&"
export * from "./case1.vue?vue&type=script&lang=js&"
import style0 from "./case1.vue?vue&type=style&index=0&id=47e539ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e539ce",
  null
  
)

export default component.exports